import {
  AutocompleteInput,
  ReferenceInput,
  useDataProvider,
  useGetIdentity,
} from 'react-admin';

import { Button } from '@mui/material';
import { UserRole } from '../@generated/schemas';
import styled from 'styled-components';
import { useFormContext } from 'react-hook-form';
import { useTranslate } from '../locales';

const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const UserInput = (props) => {
  const { watch, setValue } = useFormContext();
  const dataProvider = useDataProvider();
  const value = watch('userId');
  const translate = useTranslate();
  const { identity } = useGetIdentity();

  const defaultUserFilter = {
    deletedAt: {
      equals: null,
    },
    companyId:
      identity?.userRole !== UserRole.SuperAdmin
        ? { equals: identity.companyId }
        : {},
  };

  const handleSelectUser = async (userId) => {
    if (!value && !userId) {
      return false;
    }

    const user = await dataProvider.getOne('User', { id: value || userId });

    setValue('firstName', user.data.firstName);
    setValue('lastName', user.data.lastName);
    setValue('address', user.data.address);
    setValue('houseNumber', user.data.houseNumber);
    setValue('postCode', user.data.postCode);
    setValue('city', user.data.city);
    setValue(
      'country',
      (user.data.country || user.data.nationality || '').toUpperCase(),
    );
    setValue('birthdate', user.data.birthdate);
    setValue('companyId', null);
    setValue('company', null);
  };

  return (
    <Row>
      <ReferenceInput
        source="userId"
        reference="User"
        filter={defaultUserFilter}
        style={{ flex: 1, width: '100%' }}
        allowEmpty
        {...props}>
        <AutocompleteInput
          variant="outlined"
          size="small"
          label={translate('admin.connectToUser')}
          readOnly={props.readOnly}
          onChange={handleSelectUser}
          style={{ flex: 1, width: '100%', marginRight: 20 }}
          optionText={(record) => {
            if (!record || !record.id) {
              return translate('admin.clear');
            }
            return `${record.firstName || ''} ${record.lastName || ''} (${
              record.email
            })`;
          }}
        />
      </ReferenceInput>
      <Button
        size="small"
        disabled={!value}
        style={{ height: 35, float: 'left', marginTop: 12 }}
        variant="contained"
        onClick={handleSelectUser}>
        {translate('admin.prefillDetails')}
      </Button>
    </Row>
  );
};

export default UserInput;
